import http from '@/support/plugin/axios'

export const 

getEmailByCompanyIdAndTelephone = ( companyId, telephone ) => http.get(`companies/${companyId}/contacts/email?telephone=${telephone}`)